import Box from '@mui/material/Box';
import React, {useEffect, useRef, useState} from 'react';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import {config} from '../../../common/config/config';
import Paper from '@mui/material/Paper';
import {
    constance,
} from '../../../common/constance/constance';
import {common} from '../../../common/common';
import {styles} from '../../../common/style';
import {isMobile} from 'react-device-detect';
import {useNavigate} from 'react-router-dom';
import {PostInterface} from '../../../interface/post.interface';
import {MenuInterface} from "../../../interface/menu.interface";
import {FleaMarket} from "../../../interface/fleaMarket.interface";
import {DateTime, Duration} from "luxon";
import axios from "axios";
import {useSelector} from "react-redux";
import {RootState} from "../../../reducer";


let class_1 = {
    color: styles.fontColor.main,
    fontWeight: 500,
    width: 0.35
}
let countDownInterval: any = null;

const STATUS = {
    BEFORE: 0,
    ONGOING: 1,
    TERMINATION: 2
}

export default function PostFleaMarketListTable(props: { postList: PostInterface[], menu: MenuInterface, fleaMarketList: FleaMarket[] }) {
    console.log('[PostFleaMarketListTable]');
    const navigate = useNavigate();

    let {id, workplace, no} = common.getQuery();
    const [state, setState] = useState({
        openFleaMarket: {
            title: '',
        },
        status: STATUS.TERMINATION,
        time: new Date(), days: '00', hours: '00', minutes: '00', seconds: '00',
    })
    const commonData = useSelector((state: RootState) => state.commonData);

    function movePostList(post: PostInterface) {
        if (post.fleaMarket && new Date().getTime() > new Date(post.fleaMarket.start).getTime()) {
            navigate(`${config.url.postView}?id=${id}&no=${post.no}&workplace=${workplace}`);
        } else {
            if (post.user.id == commonData.user.id) {
                navigate(`${config.url.postView}?id=${id}&no=${post.no}&workplace=${workplace}`);
            } else {
                common.alert(`아직 플리마켓 오픈전입니다. 
            ${common.getTimeFormat(post.fleaMarket.start)} 이후에 확인하실 수 있습니다.`, '', 'info');
            }
        }
    }

    let fontSize: any = isMobile ? 'subtitle2' : 'subtitle1';

    useEffect(() => {
        console.log('[PostFleaMarketListTable] - useEffect');
        axios.get(constance.api.getFleaMarketList).then((value) => {
            console.log(value.data.fleaMarketList);
            let openFleaMarket: any = null;
            if (id == 'fleaMarket') {

                value.data.fleaMarketList = value.data.fleaMarketList.filter((fleaMarket: FleaMarket) => fleaMarket.openYN === 'Y');
                for (let fleaMarket of value.data.fleaMarketList) {
                    if (fleaMarket.openYN == 'Y') {
                        openFleaMarket = fleaMarket;

                        if (new Date().getTime() > new Date(fleaMarket.start).getTime()) {
                            setState({
                                ...state,
                                openFleaMarket: fleaMarket,
                                status: STATUS.ONGOING
                            });
                            break;
                        } else {
                            function timeReSet() {
                                let time = new Date(fleaMarket.start);
                                let diff = DateTime.fromMillis(time.getTime()).diff(DateTime.local());
                                let countDown = Duration.fromObject(diff.toObject()).toFormat('ddThh:mm:ss');

                                let days = countDown.split('T')[0];
                                let hours = countDown.split('T')[1].split(':')[0];
                                let minutes = countDown.split('T')[1].split(':')[1];
                                let seconds = countDown.split('T')[1].split(':')[2];

                                if (days.indexOf("-") > -1) days = '00';
                                if (hours.indexOf("-") > -1) hours = '00';
                                if (minutes.indexOf("-") > -1) minutes = '00';
                                if (seconds.indexOf("-") > -1) seconds = '00';

                                setState({
                                    ...state,
                                    status: STATUS.BEFORE,
                                    openFleaMarket: fleaMarket,
                                    days: days,
                                    hours: hours,
                                    minutes: minutes,
                                    seconds: seconds,
                                });
                            }

                            timeReSet();
                            countDownInterval = setInterval(() => {
                                timeReSet();
                            }, 1000);
                        }
                    } else {
                        setState({
                            ...state,
                            status: STATUS.TERMINATION
                        });
                    }
                }
            }
        }).catch(reason => {
        });
        return () => {
            if (countDownInterval) {
                clearInterval(countDownInterval);
            }
        };
    }, [])

    return (
        <React.Fragment>
            <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', p: 1}}>
                {
                    state.status == STATUS.TERMINATION ?
                        <Typography variant={isMobile ? "h6" : 'h6'}
                                    sx={{
                                        color: styles.fontColor.secondary,
                                        fontWeight: 700
                                    }}>
                            {`진행 중인 플리마켓이 없습니다.`}
                        </Typography>
                        :
                        state.status == STATUS.ONGOING ?
                            <Typography variant={isMobile ? "h5" : 'h4'}
                                        sx={{color: styles.fontColor.secondary, fontWeight: 700}}>
                                {`${state.openFleaMarket.title}`}
                            </Typography>
                            :
                            <Box sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}>
                                <Typography variant={isMobile ? "h5" : 'h4'}
                                            sx={{color: styles.fontColor.secondary, fontWeight: 700}}>
                                    {`${state.openFleaMarket.title}`}
                                </Typography>
                                {/* 카운트다운 */}
                                <Box sx={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    width: 400,
                                    mt: 2,
                                    mb: 1,
                                    pl: 1,
                                    pr: 1
                                }}>
                                    <Stack sx={{
                                        width: 1 / 4,
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center'
                                    }}>
                                        <Typography variant={isMobile ? 'h4' : 'h3'} align={'center'}
                                                    sx={{
                                                        color: '#8e8e8e',
                                                        textShadow: '2px 2px 2px #b1b1b1',
                                                        fontWeight: 700,
                                                    }}>{state.days}</Typography>
                                        <Box sx={{display: 'flex', justifyContent: 'center'}}>
                                            <Typography variant={'h6'} sx={{fontWeight: 700}}>{'D'}</Typography>
                                            <Typography variant={'h6'} sx={{color: '#8e8e8e'}}>{'ays'}</Typography>
                                        </Box>
                                    </Stack>

                                    <Stack sx={{
                                        width: 1 / 4,
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center'
                                    }}>
                                        <Typography variant={isMobile ? 'h4' : 'h3'} align={'center'}
                                                    sx={{
                                                        color: '#8e8e8e',
                                                        textShadow: '2px 2px 2px #b1b1b1',
                                                        fontWeight: 700,
                                                    }}>{state.hours}</Typography>
                                        <Box sx={{display: 'flex', justifyContent: 'center'}}>
                                            <Typography variant={'h6'} sx={{fontWeight: 700}}>{'H'}</Typography>
                                            <Typography variant={'h6'} sx={{color: '#8e8e8e'}}>{'ours'}</Typography>
                                        </Box>
                                    </Stack>

                                    <Stack sx={{
                                        width: 1 / 4,
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center'
                                    }}>
                                        <Typography variant={isMobile ? 'h4' : 'h3'} align={'center'}
                                                    sx={{
                                                        color: '#8e8e8e',
                                                        textShadow: '2px 2px 2px #b1b1b1',
                                                        fontWeight: 700,
                                                    }}>{state.minutes}</Typography>
                                        <Box sx={{display: 'flex', justifyContent: 'center'}}>
                                            <Typography variant={'h6'} sx={{fontWeight: 700}}>{'M'}</Typography>
                                            <Typography variant={'h6'} sx={{color: '#8e8e8e'}}>{'inutes'}</Typography>
                                        </Box>
                                    </Stack>

                                    <Stack sx={{
                                        width: 1 / 4,
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center'
                                    }}>
                                        <Typography variant={isMobile ? 'h4' : 'h3'} align={'center'}
                                                    sx={{
                                                        color: '#8e8e8e',
                                                        textShadow: '2px 2px 2px #b1b1b1',
                                                        fontWeight: 700,
                                                    }}>{state.seconds}</Typography>
                                        <Box sx={{display: 'flex', justifyContent: 'center'}}>
                                            <Typography variant={'h6'} sx={{fontWeight: 700}}>{'S'}</Typography>
                                            <Typography variant={'h6'} sx={{color: '#8e8e8e'}}>{'econds'}</Typography>
                                        </Box>
                                    </Stack>
                                </Box>
                            </Box>
                }


                <Box sx={{
                    width: 1,
                    maxWidth: config.maxWidth,
                    display: 'flex',
                    flexWrap: 'wrap',
                    alignItems: 'center',
                    justifyContent: 'flex-start', mb: 2,
                }}>
                    {
                        props.postList.map((post, index) => {
                            if (!!!post.fleaMarket) {
                                return;
                            }
                            post.fmSellingPrice = post.fmSellingPrice ? post.fmSellingPrice : 0;
                            let timeDiff = new Date().getTime() > new Date(post.fleaMarket.start).getTime();
                            let blurPx = timeDiff ? 0 : 7;
                            return (
                                <Paper key={index}
                                       onClick={() => movePostList(post)}
                                       variant={'elevation'}
                                       elevation={3}
                                       sx={{
                                           display: 'flex', alignItems: 'flex-start',
                                           transition: 'all ease-out 0.3s',
                                           ': hover': {
                                               background: 'var(--scc-card-hover)',
                                           },
                                           cursor: 'pointer',
                                           mt: isMobile ? 1 : 3,
                                           width: isMobile ? 1 : 0.194,
                                           p: isMobile ? 1 : 1,
                                           mr: (index + 1) % 5 == 0 ? 0 : 1,
                                           filter: `blur(${blurPx}px)`
                                       }}>
                                    <Stack sx={{width: 1}}>
                                        {/*<Box sx={{}}>
                                            <Typography variant={isMobile ? "subtitle1" : 'h6'}
                                                        align={"center"}
                                                        sx={{color: styles.fontColor.secondary, fontWeight: 700}}>
                                                {`${post.fleaMarket.title}`}
                                            </Typography>
                                        </Box>
                                        <Divider sx={{mt: 1, mb: 1}}/>
*/}
                                        <Box sx={{height: isMobile ? '' : 50, display: 'flex', alignItems: 'center'}}>
                                            <Typography variant={isMobile ? "subtitle2" : 'subtitle1'}
                                                        sx={{
                                                            color: styles.fontColor.secondary, ...styles.textKeepAll
                                                        }}
                                            >
                                                {post.replyCount > 0
                                                    ? `${post.title} [${post.replyCount}]`
                                                    : post.title}
                                            </Typography>
                                        </Box>
                                        <Divider sx={{mt: 0.5, mb: 0.5}}/>

                                        <Box sx={{
                                            display: 'flex',
                                            flexDirection: isMobile ? 'row' : 'column',
                                            width: 1
                                        }}>
                                            <Box sx={{
                                                display: 'flex', justifyContent: 'center', alignItems: 'center',
                                                // width: 1,
                                                overflow: 'hidden',
                                                width: isMobile ? 0.5 : 1,
                                                p: isMobile ? 1 : 1,
                                            }}>
                                                <img alt={''}
                                                     style={{
                                                         height: 150,
                                                         // boxShadow: '2px 2px 2px #b5b5b5',
                                                     }}
                                                     src={`${post.thumbnail}`}/>
                                            </Box>

                                            <Stack
                                                sx={{display: 'flex', width: isMobile ? 0.5 : 1, ml: isMobile ? 1 : 0}}>
                                                <Box sx={{width: 1, display: 'flex', mt: isMobile ? 2 : 2}}>
                                                    <Typography variant={fontSize}
                                                                sx={class_1}>
                                                        {`상태`}
                                                    </Typography>
                                                    <Typography variant={fontSize}
                                                                sx={{
                                                                    color: post.shareStatus == 0 ? 'red' : styles.fontColor.secondary,
                                                                    width: 0.75
                                                                }}>
                                                        {post.shareStatus == 0 ? '판매 중' : '판매 완료'}
                                                    </Typography>
                                                </Box>
                                                <Divider sx={{mt: 0.5, mb: 0.5}}/>

                                                <Box sx={{width: 1, display: 'flex'}}>
                                                    <Typography variant={fontSize}
                                                                sx={class_1}>
                                                        {`브랜드`}
                                                    </Typography>
                                                    <Typography variant={fontSize}
                                                                sx={{
                                                                    color: styles.fontColor.secondary,
                                                                    width: 0.75, ...styles.textHidden
                                                                }}>
                                                        {`${post.fmBrand}`}
                                                    </Typography>
                                                </Box>
                                                <Divider sx={{mt: 0.5, mb: 0.5}}/>

                                                <Box sx={{width: 1, display: 'flex'}}>
                                                    <Typography variant={fontSize}
                                                                sx={class_1}>
                                                        {`제품명`}
                                                    </Typography>
                                                    <Typography variant={fontSize}
                                                                sx={{
                                                                    color: styles.fontColor.secondary,
                                                                    width: 0.75, ...styles.textHidden
                                                                }}>
                                                        {`${post.fmProductName}`}
                                                    </Typography>
                                                </Box>
                                                <Divider sx={{mt: 0.5, mb: 0.5}}/>

                                                <Box sx={{width: 1, display: 'flex'}}>
                                                    <Typography variant={fontSize}
                                                                sx={class_1}>
                                                        {`시작가격`}
                                                    </Typography>
                                                    <Typography variant={fontSize}
                                                                sx={{color: styles.fontColor.secondary, width: 0.75}}>
                                                        {`${post.fmSellingPrice.toLocaleString()} 원`}
                                                    </Typography>
                                                </Box>
                                                <Divider sx={{mt: 0.5, mb: 0.5}}/>

                                                <Box sx={{width: 1, display: 'flex'}}>
                                                    <Typography variant={fontSize}
                                                                sx={class_1}>
                                                        {`등록자`}
                                                    </Typography>
                                                    <Typography variant={fontSize}
                                                                sx={{
                                                                    color: styles.fontColor.secondary,
                                                                    width: 0.75, ...styles.textHidden
                                                                }}>
                                                        {`${post.user.departmentName} ${post.user.name}`}
                                                    </Typography>
                                                </Box>
                                            </Stack>
                                        </Box>

                                    </Stack>

                                </Paper>
                            );
                        })
                    }
                </Box>
            </Box>

        </React.Fragment>
    );
}
